// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '경동제약',
  targetSheetName: '전체품목',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  requiredHeaders: [
    '구분',
    '제품코드',
    '품명',
    '성분·함량',
    'Original',
    '보험약가 (인하율 적용)',
    '수수료',
    '자체생동 여부',
    '비고',
  ],
  columnMapping: {
    drugCode: '제품코드',
    drugName: '품명',
    price: '보험약가 (인하율 적용)',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
});
